import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../../../../../../../../colorVars';

// small cancel affordance for a watched (not-yet-placed, TastyTrade-only) target line. Deliberately
// its own control rather than added to HoverBox - HoverBox is a shared, mouse-following, hover-only
// tooltip with no children slot or click handling, used by every chart line in the app.
//
// Always rendered (never returns null) so the control stays reachable via Tab regardless of mouse
// hover - a keyboard user has no way to trigger a hover state, so gating the control's existence on
// `visible` would make it permanently unreachable. Instead it's dimmed to near-invisible until the
// line is hovered OR the control itself has focus, matching the "hover to reveal" affordance for
// mouse users while keeping Tab navigation functional.
export const PendingTargetCancelControl = ({ x, y, onCancel, visible }) => {
  const [focused, setFocused] = useState(false);
  const shown = visible || focused;

  const activate = (event) => {
    event.stopPropagation();
    onCancel();
  };

  return (
    <g
      transform={`translate(${x}, ${y})`}
      role="button"
      tabIndex={0}
      aria-label="Cancel pending target"
      onClick={activate}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          activate(event);
        }
      }}
      style={{ cursor: 'pointer', opacity: shown ? 1 : 0, pointerEvents: shown ? 'auto' : 'none' }}
    >
      <circle r={7} strokeWidth={2} stroke="white" fill={colors.red} />
      <line x1={-3} y1={-3} x2={3} y2={3} stroke="white" strokeWidth={2} />
      <line x1={3} y1={-3} x2={-3} y2={3} stroke="white" strokeWidth={2} />
    </g>
  );
};

PendingTargetCancelControl.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  visible: PropTypes.bool,
};
